import React, { memo } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import styles from './styles.module.scss';

const Index = memo((props) => {
  const dispatch = useDispatch();

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const { serverGroupData } = useSelector(({localesReducer}) => localesReducer.i18n);
  const { value: scrollNumReducer, cshVal } = useSelector(({scrollNumReducer}) => scrollNumReducer);

  // 样式判断
  const normal = () => {
    if(recReSizeReducer > 1920){
      return styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      return styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      return styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      return styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      return styles.normalSm;
    }
  };

  // 判断是：桌面/移动端
  const desktopMobile = () => {
    const isDM = recReSizeReducer <= 750;
    return (
        <ul>
          { serverGroupData.list.map(item => {
            return (
              <li key={item.id}>
                <div className="innerLi">
                  <div className="innerRow"><img src={isDM ? item.iconm : item.icon} alt="" /></div>
                  <div className="innerRow"><h5 className="title"><span>{item.title}</span></h5></div>
                  <div className="innerRow"><p className="desc"><span>{item.desc}</span></p></div>
                </div>
              </li>
            )
          })}
        </ul>
    );
  };


  return (
      <div 
        className={normal()}
        ref={props.config.getRefs.innerRef}
        style={props.config.getRefs.innerStyles}
      >
        {desktopMobile()}
      </div>
  );
});
export default Index;
